module.exports = __webpack_public_path__ + "static/caminhao estrada-916e4729676c3f6a5c8458a750c1ac67.jpg";